import React, { useState } from "react";
// import CTAButton from "../CTAButton";
import FaqItem from "./FaqItem";
// import { WEBINAR_REGISTRATION } from "../../api/utils";

// const Faq = ({ leadMagnet }) => {
//   const [visibleAns, setVisibleAns] = useState();

//   // Use the faqs array from leadMagnet prop
//   const faqData = leadMagnet?.faqs || [];

//   return faqData?.length > 0 ? (
//     <>
//       <div
//         className="latest-blog py-80 "
//         // style={{ borderBottom: "2px solid rgba(25, 25, 25, 0.1)" }}
//       >
//         <div className="container text-center">
//           <div className="row pb-75 justify-content-center">
//             <div className="col-lg-8">
//               {/* <div className="text-lg-start text-center"> */}
//                 <h2 className="tc-primary head-font mb-4">
//                   Frequently Asked Questions
//                 </h2>
//               {/* </div> */}
//             </div>
//           </div>

//             <div className="row justify-content-center">
//           <div className="col-lg-8">
//             {faqData?.map((faq, index) => {
//               return (
//                 <FaqItem
//                   key={faq.id} // Use the id from the data as key
//                   faq={faq}
//                   index={index}
//                   setVisibleAns={setVisibleAns}
//                   visibleAns={visibleAns}
//                 />
//               );
//             })}
//           </div>
//           </div>
//           {/* <div className="col-lg-12">
//             <br />
//             <br />
//           </div> */}

//           {/* <div className="col-lg-12 justify-content-center d-flex">
//             <CTAButton
//               title={`Register Now At ₹${parseFloat(
//                 leadMagnet.discount_price
//               ).toFixed(0)}/- Only`}
//               link={WEBINAR_REGISTRATION}
//             />

//               <div className="text-center">
//             <button onClick={openModal} className="LM_link_btn">
//               Get My Free Audit Report
//             </button>
//           </div>
//           </div> */}
//         </div>
//       </div>
//     </>
//   ) : null;
// };

// export default Faq;
const Faq = ({ leadMagnet }) => {
  const [visibleAns, setVisibleAns] = useState();
  const faqData = leadMagnet?.faqs || [];

  return faqData?.length > 0 ? (
    <>
      <div className="latest-blog py-80">
        <div className="container text-center"> {/* ✅ Center everything */}
          <div className="row pb-75 justify-content-center">
            <div className="col-lg-8 text-center"> {/* ✅ Limit width so it looks nice */}
              <h2 className="tc-primary head-font mb-4">
                Frequently Asked Questions
              </h2>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-12"> {/* ✅ Center FAQs */}
              {faqData?.map((faq, index) => (
                <FaqItem
                  key={faq.id}
                  faq={faq}
                  index={index}
                  setVisibleAns={setVisibleAns}
                  visibleAns={visibleAns}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  ) : null;
};

export default Faq;